export default __webpack_public_path__ + "static/media/womens_diamond_band.8d2b5e31.webp";